// Modal content launched from Study Locations tab
// TODO: remove if not being used
import React, { useState, useEffect } from "react"
import "./DeleteSite.scss"
// Components
import { FormButtons } from "components-design-system"

const DeleteSite = ({ onOpenModal, onDeleteSite, gridProps, formData }) => {
  const [facilityName, setFacilityName] = useState("")
  const [address, setAddress] = useState("")
  const [contact, setContact] = useState("")
  const [contactBackup, setContactBackup] = useState("")
  const [investigators, setInvestigators] = useState(0)
  let data = null
  if (gridProps && gridProps.data) {
    data = gridProps.data
  }

  useEffect(() => {
    if (data && formData && formData.facility) {
      const { address, name } = formData.facility
      if (name) setFacilityName(name)
      if (address) {
        const { city, country, state, zip } = address
        setAddress([city, state, zip, country].filter((item) => item && item.length > 0).join(", "))
      }
    }

    if (data && formData && formData.contact) {
      const { first_name, middle_name, last_name, degrees, phone, phone_ext, email } = formData.contact
      let fullName = [first_name, middle_name, last_name].filter((item) => item && item.length > 0).join(" ")
      let fullNameDegree = [fullName, degrees].filter((item) => item && item.length > 0).join(", ")
      let phoneNumber = [phone, phone_ext].filter((item) => item && item.length > 0).join(" ext: ")
      setContact([fullNameDegree, phoneNumber, email].filter((item) => item && item.length > 0).join(" | "))
    }

    if (data && formData && formData.contact_backup) {
      const { first_name, middle_name, last_name, degrees, phone, phone_ext, email } = formData.contact_backup
      let fullName = [first_name, middle_name, last_name].filter((item) => item && item.length > 0).join(" ")
      let fullNameDegree = [fullName, degrees].filter((item) => item && item.length > 0).join(", ")
      let phoneNumber = [phone, phone_ext].filter((item) => item && item.length > 0).join(" ext: ")
      setContactBackup([fullNameDegree, phoneNumber, email].filter((item) => item && item.length > 0).join(" | "))
    }

    if (data && formData && formData.investigator) {
      setInvestigators(formData.investigator.length)
    }
  }, [data])

  const onBack = () => {
    onOpenModal("edit-site", gridProps)
  }

  return (
    <div>
      <div className="delete-site-popup-wrapper">
        <div
          className="delete-site-popup-row"
          style={{ marginBottom: 23 }}
        >
          <div className="delete-site-popup-title">{facilityName}</div>
          <span className="delete-site-popup-text">{address}</span>
        </div>
        {contact && (
          <div className="delete-site-popup-row">
            <div className="delete-site-popup-subtitle ">Primary Contact</div>
            <span className="delete-site-popup-text">{contact}</span>
          </div>
        )}
        {contactBackup && (
          <div className="delete-site-popup-row">
            <div className="delete-site-popup-subtitle ">Backup Contact</div>
            <span className="delete-site-popup-text">{contactBackup}</span>
          </div>
        )}
        <div className="delete-site-popup-row">
          <span className="delete-site-popup-text">Investigators: [{investigators}]</span>
        </div>
      </div>
      <div className="delete-site-action-container">
        <FormButtons
          size="large"
          onCancel={() => onBack()}
          onOk={() => onDeleteSite(gridProps)}
          okButtonProps={{
            danger: true,
          }}
        />
      </div>
    </div>
  )
}

export default DeleteSite
